<template>
  <div class="main-div" style="height: 700px;">
    <xr-layout :layoutConfigure="layoutConfigure" >
      <template slot="west">
        <xr-table ref="xrTable" :configure="configure"></xr-table>
      </template>
      <template slot="center">
        <xr-data-table ref="xrDataTable" :configure="dataConfigure"></xr-data-table>
      </template>
    </xr-layout>
  </div>

</template>

<script>
  import XrDataTable from '../../../XrTable/dataTable'
  //金属的人员列表,需要传入orgId 显示所有具有部门权限的人
  export default {
    name: "pageMetalSelectUser",
    data (){
      return {
        layoutConfigure:{
          westWidth: '590px',
          centerWidth: '590px',
          centerHeight: '684px',
          westHeight: '684px'
        },
        configure: {
          url: '/web/service?method=tCoreUser_pageMetalSelectList&orgId=-1',
          isShowSearch: true,
          defaultNoLoadData: true,
          isSelectFirst: true,
          pagination: false,
          idField: 'id',
          // tableHeight: '600px',
          columns: [
            {
              field: 'ck',
              width: 60,
            },
            {
              field: 'id',
              title: '账号',
              width: 120,
              condition: {
                searchType: 'input',
                searchName: 'idSearch',
                value: ''
              },
            },
            {
              field: 'userName',
              title: '用户名称',
              width: 120,
              condition: {
                searchType: 'input',
                searchName: 'userNameSearch',
                value:''
              },
            },
            {
              field: 'orgId',
              title: '所属部门',
              condition: {
                searchType: 'select',
                searchName: 'orgIdSearch',
                value:'',
                selectList:[]
              },
            }
          ],
          toolbar: [
            {
              text: '添加',
              iconCls: 'wk wk-add',
              that: this,
              handler: function () {
                this.that.addSelectedUser();
              }
            }
          ]
        },
        dataConfigure: {
          isShowSearch: true,
          defaultNoLoadData: true,
          isSelectFirst: true,
          pagination: false,
          idField: 'id',
          // tableHeight: '600px',
          columns: [
            {
              field: 'id',
              title: '账号',
              width: 120,
              condition: {
                searchType: 'input',
                searchName: 'idSearch',
                value:''
              },
            },
            {
              field: 'userName',
              title: '用户名称',
              width: 120,
              condition: {
                searchType: 'input',
                searchName: 'userNameSearch',
                value:''
              },
            },
            {
              field: 'orgId',
              title: '所属部门',
              condition: {
                searchType: 'select',
                searchName: 'orgIdSearch',
                value:'',
                selectList:[]
              },
            }
          ],
          toolbar: [
            {
              text: '确认',
              iconCls: 'wk wk-list2',
              that: this,
              handler: function () {
                this.that.getSelectedValue();
              }
            },
            {
              text: '取消',
              iconCls: 'wk wk-cancel2',
              that: this,
              handler: function () {
                this.that.handleCloseDialog();
              }
            }
          ],
          tableData:[   //数据列表

          ]
        },
      }
    },
    components: {
      XrDataTable
    },
    methods: {
      // type 应该是userMetalPageSelect 之前部分传入,暂时无用
      init(orgId,type) {
        this.initData(orgId, type)
      },

      //初始化数据  orgId:机构类型（）
      initData(orgId, type){
        this.dataConfigure.tableData = [];
        return this.request({
          method:'post',
          url:'/web/service',
          params:{
            'method':'tCoreUser_getPageSelectListInfo'
          }
        }).then((response) =>{          //这里使用了ES6的语法
          // 请求成功返回的数据
          //如果返回编码不为0，提示失败语
          if(response.code !== 0){
            this.$message.error(response.msg);
            return false;
          }
          let orgList = response.data.orgList;
          this.configure.columns[3].condition.selectList = orgList;
          this.configure.url = '/web/service?method=tCoreUser_pageMetalSelectList&orgId=' + orgId
          this.$refs.xrTable.configure = this.configure;
          this.$nextTick(()=>{
            this.$refs.xrTable.getData();
            console.log("111")
            this.dataConfigure.columns[2].condition.selectList = orgList;
            this.$refs.xrDataTable.configure = this.dataConfigure;
          })
        })
      },
      //添加选中的用户
      addSelectedUser(){
        //1、获取以前选中的数据
        let selectedData = this.dataConfigure.tableData;
        let selectedStr = ',';
        if(selectedData != null && selectedData.length > 0){
          for (let i = 0; i < selectedData.length; i++) {
            selectedStr += selectedData[i].id + ',';
          }
        }

        //2、获取当前选中的，添加进右边的列表
        let list = this.$refs.xrTable.multipleSelectionItem
        if(list == null || list.length < 1){
          return false;
        }
        for (let i = 0; i < list.length; i++) {
          if(selectedStr.indexOf(',' + list[i].id + ',') == -1){
            selectedData.push(list[i]);
          }
        }

        //3、将组装后的tableData放回去
        this.dataConfigure.tableData = selectedData;
      },
      //关闭窗口
      handleCloseDialog(){
        this.dialogVisible = false;
        this.$emit('cancelMethod');
      },
      //获取选中的值
      getSelectedValue(){
        let selectIds = '';
        let selectNames = '';
        let selectedData = this.dataConfigure.tableData;
        if(selectedData == null || selectedData.length < 1){
          alert('请选择！');
          return false;
        }
        for (let i = 0; i < selectedData.length; i++) {
          if(selectIds == ''){
            selectIds = selectedData[i].id;
            selectNames = selectedData[i].userName;
          }else{
            selectIds += ',' + selectedData[i].id;
            selectNames += ',' + selectedData[i].userName;
          }
        }
        this.$emit('confirmMethod',selectIds,selectNames);
      }
    }
  }
</script>





// WEBPACK FOOTER //
// src/components/PageSelect/core/user/userMetalPageSelect.vue